const formatMetric = (value, isLoss) => {
    if (value == null) return '-'
    const formatted = isLoss ? value.toFixed(5) : (value * 100).toFixed(2)
    return `${formatted.replace(/\.?0+$/, '')}${isLoss ? '' : '%'}`
}

const SummaryItem = ({ label, valValue, trainValue, isLoss, variant = 'default' }) => {
    const labelColor = variant === 'highlight' ? 'text-violet-400' : 'text-gray-400'
    return (
        <div>
            <div className={`text-xs font-semibold ${labelColor} uppercase`}>{label}</div>
            <div className="text-2xl font-bold my-2">{formatMetric(valValue, isLoss)}</div>
            <div className={`text-xs ${labelColor}`}>
                Train: {formatMetric(trainValue, isLoss)}
            </div>
        </div>
    )
}

const TrainingReportSummary = ({ data }) => {
    if (!data || data.length === 0) return null

    const hasValidation = data.some(d => d.val_loss != null)

    // Matches the trainer's checkpoint criterion: lowest loss
    const lossMetric = hasValidation ? 'val_loss' : 'tr_loss'
    const bestEpoch = data.reduce((best, current) => {
        const bestVal = best[lossMetric] ?? Infinity
        const currentVal = current[lossMetric] ?? Infinity
        return currentVal < bestVal ? current : best
    })

    const finalEpoch = data[data.length - 1]

    return (
        <div className="space-y-4">
            {/* Final Epoch Summary */}
            <div className="border rounded-lg p-6 bg-white">
                <div className="font-semibold text-gray-700 mb-4">Final Epoch Summary</div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <SummaryItem label="Loss" valValue={finalEpoch.val_loss} trainValue={finalEpoch.tr_loss} isLoss />
                    <SummaryItem label="F1-Score" valValue={finalEpoch.val_fscore} trainValue={finalEpoch.tr_fscore} />
                    <SummaryItem label="Precision" valValue={finalEpoch.val_precision} trainValue={finalEpoch.tr_precision} />
                    <SummaryItem label="Recall" valValue={finalEpoch.val_recall} trainValue={finalEpoch.tr_recall} />
                </div>
            </div>

            {/* Best Epoch Summary */}
            <div className="rounded-lg p-6 bg-violet-100 border border-violet-500">
                <div className="font-semibold text-violet-700">Best Epoch Summary · Epoch {bestEpoch.epoch}</div>
                <div className="text-xs text-violet-400 mb-4">
                    Lowest {hasValidation ? 'validation' : 'training'} loss
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <SummaryItem label="Loss" valValue={bestEpoch.val_loss} trainValue={bestEpoch.tr_loss} isLoss variant="highlight" />
                    <SummaryItem label="F1-Score" valValue={bestEpoch.val_fscore} trainValue={bestEpoch.tr_fscore} variant="highlight" />
                    <SummaryItem label="Precision" valValue={bestEpoch.val_precision} trainValue={bestEpoch.tr_precision} variant="highlight" />
                    <SummaryItem label="Recall" valValue={bestEpoch.val_recall} trainValue={bestEpoch.tr_recall} variant="highlight" />
                </div>
            </div>
        </div>
    )
}

export default TrainingReportSummary
